import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  TrendingCampaignsLoadAction,
  TrendingCampaignsLoadFulfilledAction,
} from '../../domains/trendingCampaigns/loadActions.types';
import { getTrendingCampaignsKey } from '../../domains/trendingCampaigns/selectors';

import { TrendingCampaigns } from './types';

const initialState: TrendingCampaigns = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const updateTrendingCampaigns = (state: TrendingCampaigns, action: TrendingCampaignsLoadFulfilledAction) => {
  const { entities, options } = action.payload;

  return moveToFulfilled(state, {
    [getTrendingCampaignsKey(options)]: {
      id: getTrendingCampaignsKey(options),
      campaignIds: entities.trendingCampaigns.campaignIds,
      cursor: entities.trendingCampaigns.cursor,
      hasNextPage: entities.trendingCampaigns.hasNextPage,
    },
  });
};

const reducer: Reducer<TrendingCampaigns, TrendingCampaignsLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'TRENDING_CAMPAIGNS.LOAD_PENDING':
      return moveToPending(state, [getTrendingCampaignsKey(action.payload.options)]);
    case 'TRENDING_CAMPAIGNS.LOAD_FULFILLED':
      return updateTrendingCampaigns(state, action);
    case 'TRENDING_CAMPAIGNS.LOAD_REJECTED':
      return moveToRejected(state, [getTrendingCampaignsKey(action.payload.options)], action.payload.error);
    default:
      return state;
  }
};

export default reducer;
